module.exports = __webpack_public_path__ + "static/arianna-huffington-7c7bc6445807f475c495ebd22cc6d14b.jpg";